import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import QuoteForm from '../../components/feature/QuoteForm';

export default function About() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-24 sm:pt-32 pb-12 sm:pb-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="text-orange-400 text-xs sm:text-sm mb-3 sm:mb-4 tracking-wider">Home / About</p>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              ABOUT US
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              Lincoln's trusted asphalt and concrete paving experts since 2010
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center mb-12 sm:mb-16 md:mb-20">
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-gray-900 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Your Local Lincoln Asphalt & Concrete Specialists
              </h2>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-4 sm:mb-6">
                For over 15 years, we've been Lincoln, Nebraska's premier asphalt and concrete paving contractor. Our family-owned business has built a reputation on quality workmanship, honest pricing, and exceptional customer service. From residential driveways to commercial parking lots, we treat every project with the same level of care and professionalism.
              </p>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-4 sm:mb-6">
                We understand that your driveway or parking lot is a significant investment. That's why we use only the highest quality materials and proven paving techniques to ensure your asphalt or concrete surface lasts for decades. Our team of experienced professionals takes pride in delivering beautiful, durable results that exceed expectations.
              </p>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                Whether you need a new asphalt driveway installation, concrete repair, sealcoating, or emergency pothole repair in Lincoln, we're here to help. We're fully licensed, bonded, and insured, giving you complete peace of mind throughout your paving project.
              </p>
            </div>
            <div>
              <img
                src="https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/2ef8a32f006bdd212c2149b4186b14fb.jpeg"
                alt="Lincoln NE asphalt paving team"
                className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
          </div>

          {/* Our Story */}
          <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 md:p-12 mb-12 sm:mb-16 md:mb-20">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8 text-gray-900 text-center leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Our Story
            </h2>
            <div className="max-w-4xl mx-auto">
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-4 sm:mb-6">
                Founded in 2010, our company started with a simple mission: provide Lincoln homeowners and businesses with honest, high-quality asphalt and concrete paving services at fair prices. What began as a small operation with just two crew members has grown into one of Lincoln's most trusted paving contractors, completing over 500 successful projects throughout Lancaster County.
              </p>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-4 sm:mb-6">
                Our founder grew up in Lincoln and learned the paving trade from his father, who worked in the industry for over 30 years. This deep-rooted knowledge of asphalt and concrete work, combined with modern techniques and equipment, allows us to deliver superior results on every job. We've paved driveways in every Lincoln neighborhood, from downtown to the suburbs, and have become the go-to contractor for commercial parking lot projects.
              </p>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
                Today, we're proud to be a cornerstone of the Lincoln community. We sponsor local youth sports teams, support neighborhood events, and employ skilled workers from right here in Nebraska. When you choose us for your asphalt or concrete project, you're not just getting expert paving services—you're supporting a local Lincoln business that cares about this community.
              </p>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-12 sm:mb-16 md:mb-20">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-12 text-gray-900 text-center leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Why Lincoln Trusts Us
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
              <div className="bg-white border-2 border-gray-200 rounded-xl p-6 sm:p-8 hover:border-orange-600 transition-colors">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-award-line text-2xl sm:text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-900">15+ Years Experience</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  Over a decade of expert asphalt and concrete paving in Lincoln. We've seen it all and know how to handle any paving challenge, from simple driveway repairs to complex commercial projects.
                </p>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-xl p-6 sm:p-8 hover:border-orange-600 transition-colors">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-shield-check-line text-2xl sm:text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-900">Licensed & Insured</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  Fully licensed, bonded, and insured for your protection. We carry comprehensive liability insurance and workers' compensation coverage, so you're never at risk during your paving project.
                </p>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-xl p-6 sm:p-8 hover:border-orange-600 transition-colors">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-star-line text-2xl sm:text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-900">500+ Happy Customers</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  Rated 4.9 out of 5 stars by Lincoln homeowners and businesses. Our reputation speaks for itself—we've built lasting relationships with customers throughout Lancaster County.
                </p>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-xl p-6 sm:p-8 hover:border-orange-600 transition-colors">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-tools-line text-2xl sm:text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-900">Quality Materials</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  We use only premium asphalt and concrete materials from trusted suppliers. Our hot-mix asphalt and high-grade concrete ensure your driveway or parking lot stands up to Nebraska's harsh weather.
                </p>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-xl p-6 sm:p-8 hover:border-orange-600 transition-colors">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-team-line text-2xl sm:text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-900">Expert Crew</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  Our experienced paving professionals are trained in the latest techniques and safety protocols. Every crew member is background-checked, drug-tested, and committed to delivering exceptional results.
                </p>
              </div>

              <div className="bg-white border-2 border-gray-200 rounded-xl p-6 sm:p-8 hover:border-orange-600 transition-colors">
                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                  <i className="ri-money-dollar-circle-line text-2xl sm:text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-900">Fair Pricing</h3>
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                  Transparent, competitive pricing with no hidden fees. We provide detailed written estimates and work within your budget to deliver the best value for your asphalt or concrete project.
                </p>
              </div>
            </div>
          </div>

          {/* Our Services Overview */}
          <div className="bg-gradient-to-br from-orange-600 to-orange-700 rounded-2xl p-6 sm:p-8 md:p-12 text-white mb-12 sm:mb-16 md:mb-20">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8 text-center leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Comprehensive Paving Services
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 max-w-4xl mx-auto">
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-xl sm:text-2xl mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-base sm:text-lg">Asphalt Driveway Installation</strong>
                  <p className="text-orange-100 mt-1 text-sm sm:text-base">New residential and commercial asphalt paving</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-xl sm:text-2xl mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-base sm:text-lg">Concrete Driveway Work</strong>
                  <p className="text-orange-100 mt-1 text-sm sm:text-base">Concrete installation, repair, and stamped concrete</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-xl sm:text-2xl mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-base sm:text-lg">Asphalt Repair & Patching</strong>
                  <p className="text-orange-100 mt-1 text-sm sm:text-base">Fix cracks, potholes, and damaged pavement</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-xl sm:text-2xl mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-base sm:text-lg">Sealcoating & Resurfacing</strong>
                  <p className="text-orange-100 mt-1 text-sm sm:text-base">Protect and extend your asphalt's lifespan</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-xl sm:text-2xl mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-base sm:text-lg">Commercial Parking Lots</strong>
                  <p className="text-orange-100 mt-1 text-sm sm:text-base">Large-scale paving, striping, and maintenance</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-checkbox-circle-fill text-xl sm:text-2xl mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-base sm:text-lg">Emergency Repairs</strong>
                  <p className="text-orange-100 mt-1 text-sm sm:text-base">Fast response for urgent pothole and damage repair</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-gray-900 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Ready to Start Your Paving Project?
              </h2>
              <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
                Get your free estimate today! We'll visit your Lincoln property, assess your needs, and provide a detailed quote with no obligation. Our team is ready to transform your driveway or parking lot with professional asphalt or concrete paving services.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="tel:3084705637" className="bg-orange-600 text-white px-6 sm:px-8 py-4 rounded-lg font-semibold hover:bg-orange-700 transition-colors text-center whitespace-nowrap cursor-pointer min-h-[56px] flex items-center justify-center text-base sm:text-lg">
                  CALL (308) 470-5637
                </a>
                <a href="/contact" className="bg-gray-900 text-white px-6 sm:px-8 py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors text-center whitespace-nowrap cursor-pointer min-h-[56px] flex items-center justify-center text-base sm:text-lg">
                  REQUEST QUOTE
                </a>
              </div>
            </div>
            <div>
              <QuoteForm variant="light" />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
